// Define globals
global.jQuery = require('jquery')
global.$ = require('jquery')
global._ = require('lodash')

// Require vendors
require('./vendor/openseadragon/openseadragon.min')
require('./vendor/openseadragon-viewerinputhook.min')
require('./vendor/google-analytics')
require('bootstrap-sass')
